<template>
  <div class="route-modal">
    <v-container class="route-modal-container" v-click-outside="close">
      <v-card>
        <v-container>
          <h1 class="text-center">Contact Us</h1>
          <v-form ref="form">
            <v-text-field v-model="name" label="Name" required filled></v-text-field>

            <v-text-field v-model="email" label="E-mail" required filled></v-text-field>

            <v-textarea v-model="message" filled label="Message" required></v-textarea>

            <div class="d-flex justify-center">
              <v-btn rounded color="primary" class="mr-4">Send Message</v-btn>
            </div>
          </v-form>
        </v-container>
      </v-card>
    </v-container>
    <v-btn x-large icon color="white" class="close-btn" :to="{name: 'home'}">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </div>
</template>

<script>
import _ from "lodash";
import api from "../api";

export default {
  data: () => ({
    mounted: false,
    name: "",
    message: "",
    email: ""
  }),

  computed: {},

  methods: {
    close() {
      if (this.mounted) this.$router.push({ name: "home" });
      // this.$router.push({ name: "search" });
    }
  },

  mounted: function() {
    setTimeout(() => (this.mounted = true), 0);
  }
};
</script>

